import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 25"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M5 23.75c0 .688.563 1.25 1.25 1.25h5c.688 0 1.25-.562 1.25-1.25V22.5H5zM8.75 0C3.925 0 0 3.925 0 8.75c0 2.975 1.488 5.588 3.75 7.175v2.825c0 .688.563 1.25 1.25 1.25h7.5c.688 0 1.25-.562 1.25-1.25v-2.825c2.262-1.588 3.75-4.2 3.75-7.175C17.5 3.925 13.575 0 8.75 0m2.5 14.625V17.5h-5v-2.875C4.35 13.287 2.5 11.912 2.5 8.75 2.5 5.3 5.3 2.5 8.75 2.5S15 5.3 15 8.75c0 3.113-1.887 4.563-3.75 5.875"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }